import { guardNullOrUndefined } from '../utils/guards';
import { TRACK_EVENT, LOCATION_CHANGE, RETRACK_ADS_IMPRESSIONS } from './constants';

export const trackEvent = data => {
  guardNullOrUndefined(data);
  return { type: TRACK_EVENT, data };
};

export const locationChange = data => ({ type: LOCATION_CHANGE, data });

export const enableTrackingImpressions = () => ({ type: 'ENABLE_TRACKING_IMPRESSIONS' });

export const disableTrackingImpressions = () => ({ type: 'DISABLE_TRACKING_IMPRESSIONS' });

export const reTrackImpressions = () => ({ type: RETRACK_ADS_IMPRESSIONS });



// WEBPACK FOOTER //
// ./app/tracking/actions.js